import { api } from '../api/client';
import { API_COLLECTION_INGEST_URL, API_COLLECTION_SCHEMA_URL } from '../utils';

/**
 * What a collection accepts, per card, for this person (keepr-api
 * docs/SCHEMA.md § Collection schema): each card's flattened elements, an
 * element hidden from them left out and the rest carrying `access`, and a
 * parent's `familyCards`, which are written in their own sub-collection.
 */
export async function getCollectionSchema(collectionId) {
	const { data } = await api.get(API_COLLECTION_SCHEMA_URL(collectionId));
	return data;
}

/**
 * One call of batch ingest (keepr-api docs/SCHEMA.md § Batch ingest). Always a
 * 200 that answers row by row: `{ runId, summary, rows }`. A malformed
 * envelope, no write here, or an archived collection rejects with the axios
 * error, and nothing is written.
 */
export async function ingestRows(collectionId, body, config) {
	const { data } = await api.post(API_COLLECTION_INGEST_URL(collectionId), body, config);
	return data;
}
